module.exports = __webpack_public_path__ + "static/media/booking_2.a756f8fb.svg";